module.exports = __webpack_public_path__ + "4f9680fbf01f4aa9cd11eb77f1c714dd.ttf";